module.exports = __webpack_public_path__ + "img/icon_QQ.a4c959e0.png";